module.exports = {
      id: "audio-play-usage",
      viewBox: "0 0 384 512",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#audio-play",
      toString: function () {
        return this.url;
      }
    }